// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import './assets/css/common.css'
import './assets/js/fontsize.js'

import Axios from 'axios'
import Vuex from 'vuex'
import store from '../vuex/store'

Vue.use(Vuex)
// Axios.defaults.baseURL = 'http://localhost:8080/static/services/';
Vue.prototype.$ajax = Axios;
Vue.config.productionTip = false;


// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;

//设置默认请求头
Axios.defaults.headers.post['Content-Type'] = 'application/json';

//引入mint-ui
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)

//使用懒加载配置
import { Lazyload } from 'mint-ui';
Vue.use(Lazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 3
})

 //  --------------- Axios：配置全局拦截器  --------------------
// 添加请求拦截器
Axios.interceptors.request.use(function (configs) {
  // 在发送请求之前做些什么
  //显示加载图标
  MintUI.Indicator.open({
    text: 'Loading...',
    spinnerType: 'fading-circle'
  });
  return configs;
}, function (error) {
  // 对请求错误做些什么
  MintUI.Indicator.close();
  return Promise.reject(error);
});

// 添加响应拦截器
Axios.interceptors.response.use(function (configs) {
  // 对响应数据做点什么
  //隐藏加载图标
  MintUI.Indicator.close();
  return configs;
}, function (error) {
  // 对响应错误做点什么
  //隐藏加载图标
  MintUI.Indicator.close();
  return Promise.reject(error);
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js